


export default{
    data(){
        return{
            apis:{//接口列表
                members: '/sh/enum/member/list',//获取枚举成员列表
            },
            enums:[],//枚举成员列表
            selections: [],//选中的枚举成员
        }
    },
    model:{
        prop: 'value',
        event: 'change'
    },
    props:{
        enumCode: {//枚举编码，字符串
            type: String,
            default: null
        },
        size:{//输入框尺寸
            type:String,
            default: 'small'
        },
        itemWidth:{//选项样式文件
            type:String,
            default: ''
        },
        value:{//枚举成员值
            type: Array,
            default(){
                return [];
            }
        },
        disabled:{//禁用
            type: Boolean,
            default: false
        },
    },
    watch:{
        value(){
            const me = this;
            me.selections = me.value;
        }
    },
    mounted() {
        const me = this;
        me.enums = [];
        me.loadEnum();
    },
    methods: {
        loadEnum() {//获取成员列表
            const me = this;
            if(!me.enumCode){
                return;
            }
            me.$post({
                url: me.apis.members,
                params:{
                    enumCode: me.enumCode,
                    page : 1
                }
            }).then(rsp => {
                me.enums = rsp.retList;
                me.selections = me.value;
            })
        },
        getEnum(){//获取选中的枚举成员，返回列表
            const me = this;
            if(!me.enums || me.enums.length <= 0 || !me.selections || me.selections.length <= 0){
                return null;
            }
            let ems = [];
            for(let i in me.enums){
                let em = me.enums[i];
                if(me.selections.indexOf(em.value)){
                    ems.push(em);
                }
            }
            return ems;
        },
        change(){//选中值发生变化时触发
            const me = this;
            me.$emit('change', me.selections);
        },
    }
}


// WEBPACK FOOTER //
// ./src/components/base/view/Enum/cmps/checkbox/src/checkbox.js